import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowRight_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2929 6.29289C21.6834 5.90237 22.3166 5.90237 22.7071 6.29289L35.7071 19.2929C35.8946 19.4804 36 19.7348 36 20C36 20.2652 35.8946 20.5196 35.7071 20.7071L22.7071 33.7071C22.3166 34.0976 21.6834 34.0976 21.2929 33.7071C20.9024 33.3166 20.9024 32.6834 21.2929 32.2929L32.5858 21L5 21C4.44772 21 4 20.5523 4 20C4 19.4477 4.44772 19 5 19L32.5858 19L21.2929 7.70711C20.9024 7.31658 20.9024 6.68342 21.2929 6.29289Z"
            />
        </SvgStyled>
    );
};

export default ArrowRight_xl;
